import { render } from "./survivaldata_popup.vue?vue&type=template&id=059cfa58&scoped=true"
import script from "./survivaldata_popup.js?vue&type=script&lang=js"
export * from "./survivaldata_popup.js?vue&type=script&lang=js"

import "./survivaldata_popup.vue?vue&type=style&index=0&id=059cfa58&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-059cfa58"]])

export default __exports__